import React from 'react';
import classNames from 'classnames';

// eslint-disable-next-line
const Item = ({
  item,
  index,
  isSelected,
  isActive,
  getItemProps,
  children,
  renderItem,
  searchValue,
  disabled,
  className,
}) => (
  <li
    className={classNames(
      className,
      { 'Select--item': true },
      { active: isActive },
      { 'Select--highlighted active': !disabled && isSelected },
    )}
    {...getItemProps({
      key: item && item.key,
      index,
      item,
      disabled,
    })}
  >
    <a>{(item && (renderItem ? renderItem(item, searchValue, index) : item.label)) || children}</a>
  </li>
);

export default Item;
